import React from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import LoadingIndicator from '@/components/LoadingIndicator'

export const LoadingDialog = (props) => {
  return (
    <React.Fragment>
      <BasicHeader {...props} />
      <ModalBody>
        <LoadingIndicator />
      </ModalBody>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/dialogs/common/loadingDialog.js